import { useMutation } from '@tanstack/react-query';
import { apiUploadPrioShareFile } from '../../../api';

interface UploadPrioShareFileParams {
  projectExtensionId: string;
  prioShareId: string;
  file: File;
  alternativeFilename?: string;
  onProgress?: (percent: number) => void;
}

export function useUploadPrioShareFile() {
  return useMutation({
    mutationFn: async (params: UploadPrioShareFileParams) => {
      return apiUploadPrioShareFile(
        params.projectExtensionId,
        params.prioShareId,
        params.file,
        params.alternativeFilename,
        params.onProgress
      );
    },
  });
}
